import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle">
                    Evergreen report highlights all pages that lasted in search for{' '}
                    {this.props.currentValue} number of weeks over the past 365 days. The default
                    number of weeks is 4. You can change it by clicking the gear button below.
                </div>
            </>
        );
    }
}

export default ExtraButtons;
